<div class="loading-indicator" *ngIf="isLoading">
  <mat-progress-spinner mode="indeterminate" color="accent"></mat-progress-spinner>
</div>
<div fxLayoutAlign="center" style="margin-top: 20px;">
  <h1>{{data?.exemptionRequestType?.description}}</h1>
</div>
<div fxLayoutAlign="center">
  <p style="font-weight: bold">Registration Control # {{data?.registrationControlNumber}}
  </p>
</div>
<div class="d-flex">
  <div class="col-2"></div>
  <div class="col-8">
    <div class="row">
      <div>
        <mat-tab-group [selectedIndex]="selectedIndex" #tabs (selectedTabChange)="tabChanged($event)">
          <mat-tab label="Verification">
            <app-external-verification-tab [QualificationTab]="QualificationTab"
              [QualificationTypes]="qualificationTypes" [verificationError]="verificationError" >
            </app-external-verification-tab>
          </mat-tab>
          <mat-tab *ngIf="!isVolRevocation" label="Request a Copy">
            <app-request-copy-tab [StateTypes]="stateTypes" (onSendToChanged)="sendToModeSelected($event)" [RequestCopyTab]="RequestCopyTab">
            </app-request-copy-tab>
          </mat-tab>
          <mat-tab *ngIf="isVolRevocation" label="Confirmation">
            <app-external-confirmation-tab (oninjuryModeChanged)="oninjuryModeSelected($event)" [data]="data" [IsExternal]="true" [CsPLicense]="data?.cspLicense"  [FillingType]="data?.exemptionRequestType?.code"
              [QualificationTypes]="qualificationTypes" [CountyTypes]="countyTypes" [CityTypes]="cityTypes"
              [StateTypes]="stateTypes" [ParentForm]="form" [ConfirmationTab]="ConfirmationTab"></app-external-confirmation-tab>
          </mat-tab>
          <mat-tab label="Signature">
            <app-signaturetab [SignatureTab]="SignatureTab"></app-signaturetab>
          </mat-tab>
          <mat-tab label="Payment">
            <ng-template matTabContent>
              <app-exernal-payment-tab [ParentForm]="form">
              </app-exernal-payment-tab>
            </ng-template>
          </mat-tab>
        </mat-tab-group>
      </div>
    </div>
    <div  class="row" style="margin-top: 20px;margin-bottom: 130px;">
      <div class="col-4">
        <button *ngIf="selectedIndex > 0" mat-raised-button
          style="margin-left: '30px'; border-radius: 5px; background-color: '#e7e3e3'; color: 'black';" [disabled]="isLoading"
          (click)="previousStep()">Back</button>
      </div>
      <div *ngIf="selectedIndex <= 3" class="col-4">
        <div><button mat-raised-button color="primary" [disabled]="isLoading" (click)="saveAndContinue()">Save & Continue</button></div>
      </div>
      <div *ngIf="selectedIndex <= 3" class="col-4" fxFlex fxLayoutAlign="end start">
        <button mat-raised-button
          style="border-radius: 5px; background-color: '#e7e3e3'; color: 'black'; margin-right: 100px;"
          (click)="onCancel()">Cancel</button>
      </div>
    </div>
  </div>
</div>
